export const EXECUTION_CONTEXT_URL_PARAM = 'landr-execution-context';
export const EXECUTION_CONTEXT_SESSION_KEY = 'landr-samples-execution-context';
